import { useEffect, useRef, useState } from 'react';
import { Row, Col, DatePicker, Checkbox, Divider } from 'antd';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { useNavigate as useHistory, useLocation, useMatch as useRouteMatch } from 'react-router-dom';
import { WarningFilled } from '@ant-design/icons';
import TerritoryService from 'services/territorio';
import Loading from 'components/loading';
import ReportHead from 'components/reportHead';
import 'jspdf-autotable';
import Card from 'react-bootstrap/Card';
import { faRectangleList } from '@fortawesome/free-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import {
  initialState as Is_newReportCompiler,
  updateFilters,
  updateData,
  updateTextFilters,
  updateTableData
} from '../../redux/reducers/NewReportCompiler.reducer';

function Head() {
  const dispatch = useDispatch();
  const {
    state = {
      loading: undefined,
      ambitiGeografici: undefined,
      unitaAmministrative: undefined,
      ambitoUA: undefined,
      checkedAmbitoGeografico: undefined,
      checkedUnitaAmministrativa: undefined,
      headerFunction: undefined,
      date: undefined,
      showZeroReports: undefined,
      showNextStep: undefined,
      stateApplied: undefined,
      showDateError: undefined
    }
  } = useLocation();

  const mainTitle = 'Unità territoriali';
  const path = useLocation().pathname;
  const firstLoad = useRef(true);
  const [loading, setLoading] = useState(state?.loading || false);
  const [ambitiGeografici, setAmbitiGeografici] = useState(state?.ambitiGeografici || []);
  const [unitaAmministrative, setUnitaAmministrative] = useState(state?.unitaAmministrative || []);
  const [ambitoUA, setAmbitoUA] = useState(state?.ambitoUA || null);
  const [checkedAmbitoGeografico, setCheckedAmbitoGeografico] = useState(state?.checkedAmbitoGeografico);
  const [checkedUnitaAmministrativa, setCheckedUnitaAmministrativa] = useState(state?.checkedUnitaAmministrativa);
  const [headerFunction, setHeaderFunction] = useState(state?.headerFunction || null);
  const [date, setDate] = useState(state?.date || null);
  const [showZeroReports, setShowZeroReports] = useState(state?.showZeroReports || false);
  const [showNextStep, setShowNextStep] = useState(state?.showNextStep || false);
  const [stateApplied, setStateApplied] = useState(state?.stateApplied || false);
  const [showDateError, setShowDateError] = useState(state?.showDateError || false);
  const history = useHistory();
  const location = useLocation();

  const snapshot = () => {
    return {
      loading,
      ambitiGeografici,
      unitaAmministrative,
      ambitoUA,
      checkedAmbitoGeografico,
      checkedUnitaAmministrativa,
      headerFunction,
      date,
      showZeroReports,
      showNextStep,
      stateApplied,
      showDateError
    };
  };

  const fetchAmbitiGeografici = async () => {
    let ret = await TerritoryService.ambitiGeografici();
    ret.data = ret.data.filter((i) => i.value?.toLowerCase() != 'paesi esteri'); // Placeholder CABLATURA
    return ret;
  };

  const fetchUnitaAmministrative = async (date, ambito) => {
    return await TerritoryService.unitaAmministrative(date, ambito, 'DATA');
  };

  const fetchAmbitoUA = async (data, unita, ambito) => {
    return await TerritoryService.ambitoUA(data, unita, ambito, 'DATA');
  };

  const isComingBack = () => {
    return firstLoad.current && location.state;
  };

  useEffect(() => {
    if (isComingBack()) return;

    dispatch(updateData({ dataAUp: null }));
    const checkData = () => {
      const { state } = location;
      if (!state) {
        setLoading(true);
        setDate(moment().format('DD-MM-YYYY'));
        if (!showDateError) {
          fetchAmbitiGeografici()
            .then(({ data }) => {
              setAmbitiGeografici(data);
              setLoading(false);
            })
            .catch(() => {
              setLoading(false);
            });
        } else {
          setLoading(false);
        }
        setStateApplied(true);
        return () => setAmbitiGeografici([]);
      } else {
        const {
          date,
          checkedAmbitoGeografico,
          checkedUnitaAmministrativa,
          unitaAmministrative,
          ambitoUA,
          ambitiGeografici
        } = state;
        setDate(date);
        setAmbitiGeografici(ambitiGeografici);
        setCheckedAmbitoGeografico(checkedAmbitoGeografico);
        setUnitaAmministrative(unitaAmministrative);
        setCheckedUnitaAmministrativa(checkedUnitaAmministrativa);
        setAmbitoUA(ambitoUA);
      }
    };
    checkData();
    return () => checkData();
  }, []);

  useEffect(() => {
    document.title = 'Unità territoriali - SITUAS';
  });

  useEffect(() => {
    if (isComingBack()) return;

    if (
      date &&
      ambitiGeografici &&
      checkedAmbitoGeografico &&
      unitaAmministrative &&
      checkedUnitaAmministrativa &&
      ambitoUA
    ) {
      setStateApplied(true);
    }
  }, [
    date,
    ambitiGeografici,
    checkedAmbitoGeografico,
    unitaAmministrative,
    checkedUnitaAmministrativa,
    ambitoUA
  ]);

  useEffect(() => {
    if (isComingBack()) return;

    if (stateApplied) {
      setCheckedAmbitoGeografico();
      setUnitaAmministrative();
      setCheckedUnitaAmministrativa();
      setAmbitoUA();
    }
    if (date) {
      dispatch(updateData({ dataDaUp: moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD') }));
    }
  }, [date]);

  useEffect(() => {
    if (isComingBack()) return;

    if (stateApplied) {
      setCheckedUnitaAmministrativa();
      if (date && checkedAmbitoGeografico) {
        setLoading(true);
        fetchUnitaAmministrative(date, checkedAmbitoGeografico.key)
          .then(({ data }) => {
            if (data?.length === 0) {
              setShowZeroReports(true);
            } else {
              setShowZeroReports(false);
              setShowNextStep(true);
            }
            setUnitaAmministrative(data);
            setLoading(false);
          })
          .catch(() => setLoading(false));
      } else {
        setUnitaAmministrative([]);
        setAmbitoUA();
      }
    }
  }, [checkedAmbitoGeografico]);

  useEffect(() => {
    if (isComingBack()) return;

    if (checkedUnitaAmministrativa && checkedAmbitoGeografico && date) {
      setShowNextStep(false);
      setLoading(true);
      fetchAmbitoUA(
        date?.replaceAll('-', '/'),
        checkedUnitaAmministrativa?.key,
        checkedAmbitoGeografico.key
      )
        .then(({ data }) => {
          if (data.items?.length === 0) {
            setShowZeroReports(true);
          } else {
            setShowZeroReports(false);
          }
          setAmbitoUA(data.items);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      setShowNextStep(true);
      setAmbitoUA();
    }
  }, [checkedUnitaAmministrativa]);  

  // Leave as last call
  useEffect(() => {
    firstLoad.current = false;
  }, []);
  return (
    <>
      <Row>
        <Col sm={0} lg={7} />
        <Col sm={23} lg={16} offset={1}>
          <h2 className="title-main">Unità territoriali</h2>
          {/* <Divider className="blue-divider" /> */}
        </Col>
      </Row>
      <Row>
         <Col xs={24} lg={7} role="search" aria-label="Ricerca nelle unità territoriali">
          {loading && <Loading fullPage={true} />}
          <h3 className="text-secondary">Criteri di ricerca {showDateError && (<span className="alert-red">*</span>)}</h3>
          {showDateError && (
            <div className="alert-red" role="alert">
              <p>Data selezionata non compatibile con periodo di disponibilità</p>
            </div>
          )}
          <form>
            <div className="unit-section-title">Report disponibili alla data</div>
            <DatePicker
              tabIndex={0}
              key={"territorio-" + date}
              format="DD/MM/YYYY"
              status={showDateError && 'error'}
              defaultValue={moment(date, 'DD/MM/YYYY')}
              disabledDate={(d) =>
                !d ||
                d.isAfter(moment()) ||
                d.isBefore(moment('17/03/1861', 'DD/MM/YYYY'))
              }
              onChange={(date) => {
                const today = moment();
                const oldest = moment('17/03/1861', 'DD/MM/YYYY');
                const dt = moment(date);

                if (oldest.diff(dt) > 0 || today.diff(dt) < 0) {
                  setShowDateError(true);
                } else {
                  const parsedDate = moment(date);
                  setShowDateError(false);
                  setDate(parsedDate.format('DD-MM-YYYY'));
                  dispatch(updateData({ dataDaUp: parsedDate.format('YYYY-MM-DD') }));
                }
              }}
              className="custom-date-picker"
              size="large"
            />
            <div>
              <fieldset role="radiogroup" aria-describedby="criteri1-desc">
                <p className="sr-only" id="criteri1-desc">
                  I risultati vengono mostrati simultaneamente all'impostazione dei filtri
                </p>
                {ambitiGeografici?.length > 0 && !showDateError && (
                  <legend className="text-secondary">Ambiti geografici</legend>
                )}
                {!showDateError &&
                  ambitiGeografici?.map((ambito, idx) => (
                    <div key={ambito.key}>
                      <Form.Check
                        id={'criteri1' + idx}
                        type="radio"
                        name="criteri1"
                        tabIndex={0}
                        label={ambito.value}
                        aria-label={ambito.value}
                        checked={ambito.key === checkedAmbitoGeografico?.key ? true : false}
                        onChange={(e) => {
                          return e.target.checked
                            ? setCheckedAmbitoGeografico(ambito)
                            : setCheckedAmbitoGeografico();
                        }}
                      />
                    </div>
                  ))}
              </fieldset>
            </div>
            <div>
              <fieldset role="radiogroup" aria-describedby="criteri2-desc">
                <p className="sr-only" id="criteri2-desc">
                  I risultati vengono mostrati simultaneamente all'impostazione dei filtri
                </p>
                {unitaAmministrative?.length > 0 && !showDateError && (
                  <legend className="text-secondary">{checkedAmbitoGeografico?.value}</legend>
                )}
                {!showDateError &&
                  unitaAmministrative?.map((ua, idx) => (
                    <div key={ua.key}>
                      <Form.Check
                        id={'criteri2' + idx}
                        type="radio"
                        name="criteri2"
                        tabIndex={0}
                        aria-label={ua.value}
                        checked={ua.key === checkedUnitaAmministrativa?.key ? true : false}
                        label={ua.value}
                        onChange={(e) => {
                          return e.target.checked
                            ? setCheckedUnitaAmministrativa(ua)
                            : setCheckedUnitaAmministrativa();
                        }}
                      />
                    </div>
                  ))}
              </fieldset>
            </div>
          </form>
        </Col>
        <Col sm={23} lg={16} className="col-report-fullwidth" offset={1}>
          <Divider className="blue-divider" />
          {checkedAmbitoGeografico &&
            showNextStep &&
            unitaAmministrative?.length > 0 &&
            ambitoUA?.length === 0 && (
              <div className="w-100 d-flex justify-content-center flex-column">
                <>
                  <div className="text-center">
                    Si prega di selezionare 1 {checkedAmbitoGeografico.value}
                  </div>
                </>
              </div>
            )}

          {/* {!checkedAmbitoGeografico ? (
            <div className="pl-4 mt-2">
              La funzione restituisce le liste delle unità territoriali disponibili e vigenti alla
              data di interesse selezionata, corredata da caratteristiche e classificazioni.
            </div>
          ) : (
            hiddenError()
          )} */}
          {!checkedUnitaAmministrativa && (
            <div className="align-on-left pr-5">
              Dopo aver selezionato la data di interesse, l'ambito geografico e l'unità territoriale il sistema propone report per tema.
            </div>
          )}
          {!checkedUnitaAmministrativa && (<>
            <div className="mt-2 territorialUnits-Cards">
              <Row>
                <Col xs={24} md={12} gutter={[16, 16]}>
                  <Card className="card-head CardBorderless">
                    <Card.Body className="custom-cards">
                      <Card.Title>
                        <h2 className="Card-Title" aria-label="Unità amministrative">
                          Unità amministrative
                        </h2>
                      </Card.Title>
                      <Card.Text>Disponibili i seguenti territori nei periodi indicati:</Card.Text>
                      <Card.Text>
                        <ul className="mt-1">
                          <li>Ripartizioni geografiche, dal 1861</li>
                          <li>Compartimenti per il periodo 1861-1947</li>
                          <li>Regioni dal 1948</li>
                          <li>Province per il periodo 1861-1947</li>
                          <li>Province o Unità territoriali sovracomunali (Uts) dal 1948</li>
                          <li>Circondari e distretti per il periodo 1861-1927</li>
                          <li>Comuni dal 1861</li>
                        </ul>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={24} md={12}>
                  <Card className="CardBorderless">
                    <Card.Body className="custom-cards">
                      <Card.Title>
                        <h2 className="Card-Title" aria-label="Unità statistiche">
                          Unità statistiche
                        </h2>
                      </Card.Title>
                      <Card.Text>Disponibile il seguente territorio nel periodo indicato:</Card.Text>
                      <Card.Text>
                        <ul className="mt-1">
                          {/*<li>*/}
                          {/*  NUTS - Nomenclatura delle unità territoriali statistiche, dal 2006*/}
                          {/*</li>*/}
                          <li>SLL - Sistemi locali del lavoro dal 2011 (9-10-2011)</li>
                          {/*<li>DI - Distretti industriali, dal 2011</li>*/}
                          {/*<li>FUA - Zone urbane funzionali, dal 2011</li>*/}
                          {/*<li>AP - Aree progetto, dal 2011</li>*/}
                        </ul>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  {/*<Card className="CardBorderless">*/} {/*Placeholder CABLATURA*/}
                  {/*  <Card.Body className="custom-cards">*/}
                  {/*    <Card.Title>*/}
                  {/*      <h2 className="Card-Title">Paesi esteri</h2>*/}
                  {/*    </Card.Title>*/}
                  {/*    <Card.Text>Liste consultabili a partire dal 1900</Card.Text>*/}
                  {/*  </Card.Body>*/}
                  {/*</Card>*/}
                </Col>
              </Row>
            </div>
            <div className="align-on-left pr-5">
              Nei prossimi rilasci del Portale la pagina sarà arricchita con nuove unità territoriali e nuovi report.
            </div>
            </>
          )}
          {checkedUnitaAmministrativa && showZeroReports && (
            <div className="w-100 d-flex justify-content-center flex-column">
              <>
                <WarningFilled style={{ fontSize: '25px' }} />
                <div className="text-center">Nessun report presente</div>
              </>
            </div>
          )}
          {!showDateError && (
            <>
              {checkedUnitaAmministrativa && (
                <div className="ricerca-counter" id="counterDiv" role='status'>
                  Risultati della ricerca:{' '}
                  <span id="counterSpan">{ambitoUA ? ambitoUA.length : ''}</span>
                </div>
              )}
              {ambitoUA?.map((ua) => {
                const periodo_dati = ua.periodo_dati
                  ?.replace('31/12/9999', moment().format('DD/MM/YYYY'))
                  .replace('Periodo dati:', '')
                  .split('-');

                return (
                  <div key={ua.id_funzione} className="mt-3 mb-3 shadow-sm territory-report">
                    <Row gutter={10} style={{ minHeight: '140px' }}>
                      <Col 
                        className="d-flex flex-column justify-content-between"
                        xs={17} md={18} lg={19} xl={21}>
                        <div>
                          <h3 className="ua-title">{ua.titolo_report}</h3>
                          <div className="ua-description text-justify">{ua.descrizione_report}</div>
                        </div>
                        <div className="ua-period text-right">
                          <span>{ua.periodo_dati?.replace('31/12/9999', moment().format('DD/MM/YYYY'))}</span>
                        </div>
                      </Col>
                      <Col
                        className="ua-buttons d-flex justify-content-around align-items-start"
                        xs={7} md={6} lg={5} xl={3}
                        style={{ paddingLeft: '12px', paddingRight: '12px' }}>
                          <button
                          aria-label={`Apri pop up informazioni report ${ua.titolo_report}`}
                          title="Apri pop up informazioni"
                          className="button-as-link button-istat-svgpath"
                          onClick={() => {
                            setHeaderFunction(ua);
                          }}>
                          <FontAwesomeIcon
                            aria-hidden="false"
                            alt=""
                            icon={faCircleInfo}
                            size="xl"/>
                        </button>
                          <button
                          aria-label={`Visualizza report ${ua.titolo_report}`}
                          title="Visualizza report"
                          className="button-as-link button-istat-svgpath"
                          onClick={() => {
                            dispatch(updateTableData(Is_newReportCompiler.tableData));
                            dispatch(updateTextFilters(Is_newReportCompiler.textFilters));
                            dispatch(updateFilters(Is_newReportCompiler.filters));
                            
                            let dtFrom = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
                            history(`/territorio/body?id=${ua.id_funzione}&dateFrom=${dtFrom}`, {
                              replace: true,
                              state: {
                                dataDa: date,
                                funzione: ua.id_funzione,
                                title: ua.titolo_report,
                                metadati: true,
                                checkedAmbitoGeografico,
                                unitaAmministrative,
                                checkedUnitaAmministrativa,
                                ambitoUA,
                                ambitiGeografici,
                                periodoDate: periodo_dati,
                                mainTitle: mainTitle,
                                percorsoBk: path,
                                descrizione: ua.descrizione_report,
                                metadati_val: ua,

                                caller_state: snapshot()
                              }
                            });
                          }}>
                          <FontAwesomeIcon
                            aria-hidden="false"
                            alt=""
                            icon={faRectangleList}
                            size="xl"/>
                        </button>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </>
          )}
        </Col>
      </Row>
      <ReportHead
        headerFunction={headerFunction}
        setHeaderFunction={setHeaderFunction}
        setLoading={setLoading}
        date={date}
      />
    </>
  );
}
export default Head;
